module.exports = __webpack_public_path__ + "img/13.f44e241d.jpg";